import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';
import {
    BOOKINGS_SUMMARY_REPORT_GET_START,
    BOOKINGS_SUMMARY_REPORT_GET_SUCCESS,
    BOOKINGS_SUMMARY_REPORT_GET_ERROR,
    BookingsSummaryReportAction
} from './BookingsSummaryReportActionsTypes';
import { BookingsSummaryReportDto } from './BookingsSummaryReportDto';
import { convertToBookingSummaryReport } from './bookingSummaryReportConverter';

export const getBookingsSummaryReport = (
    start?: string,
    end?: string
): ThunkAction<void, null, null, BookingsSummaryReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getBookingsSummaryReportStart());

        const { marketplaceId } = store.getState().login.auth;
        let url = `/bookings_summary_report?marketplace_id=${marketplaceId}`;

        if (start) url += `&start_date=${start}`;
        if (end) url += `&end_date=${end}`;

        try {
            const response: AxiosResponse<BookingsSummaryReportDto> = await ApiClient.get(
                url,
                createTokenConfig(store.getState().login.auth.token!)
            );
            dispatch(getBookingsSummaryReportSuccess(response.data));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(error());
                dispatch(showError('Too many bookings to display. Please try a shorter date range.'));
            }
        }
    };
};

const getBookingsSummaryReportStart = (): BookingsSummaryReportAction => ({
    type: BOOKINGS_SUMMARY_REPORT_GET_START
});

const getBookingsSummaryReportSuccess = (response: BookingsSummaryReportDto): BookingsSummaryReportAction => {
    const summaryReportConverted = convertToBookingSummaryReport(response);
    return {
        type: BOOKINGS_SUMMARY_REPORT_GET_SUCCESS,
        payload: {
            summary: summaryReportConverted
        }
    };
};

const error = (): BookingsSummaryReportAction => ({ type: BOOKINGS_SUMMARY_REPORT_GET_ERROR });
